import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';

/**
 * Admin editor for the per-module completion email content. The text saved
 * here is appended to the "module completed" email a learner receives when
 * they reply to (complete) this module.
 */
export default class ModuleEmailModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.article = this.attrs.article;
    this.message = Stream(this.article.attribute('courseModuleCompletionEmail') || '');
  }

  className() {
    return 'Modal--small Support-Modal';
  }

  title() {
    return app.translator.trans('deepintegrations-custom-blog-ecourse.forum.module_email.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">{this.fields().toArray()}</div>
      </div>
    );
  }

  fields() {
    const items = new ItemList();

    items.add(
      'content',
      <div className="Form-group">
        <label>{app.translator.trans('deepintegrations-custom-blog-ecourse.forum.module_email.fields.content.title')}:</label>
        <textarea
          className="FormControl"
          style={{ maxWidth: '100%', minWidth: '100%', width: '100%', minHeight: '160px' }}
          bidi={this.message}
          placeholder={app.translator.trans('deepintegrations-custom-blog-ecourse.forum.module_email.fields.content.placeholder')}
        />
        <small>{app.translator.trans('deepintegrations-custom-blog-ecourse.forum.module_email.fields.content.helper_text')}</small>
      </div>,
      30
    );

    items.add(
      'submit',
      <div className="Form-group">
        {Button.component(
          {
            type: 'submit',
            className: 'Button Button--primary SupportModal-save',
            loading: this.loading,
          },
          app.translator.trans('core.forum.composer_edit.submit_button')
        )}
      </div>,
      -10
    );

    return items;
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    app
      .request({
        method: 'PATCH',
        url: `${app.forum.attribute('apiUrl')}/course-modules/by-discussion/${this.article.id()}`,
        body: { completionEmailContent: this.message() },
      })
      .then(
        (payload) => {
          // Response is the updated discussion; refresh the cached attribute.
          app.store.pushPayload(payload);

          this.hide();
          m.redraw();
        },
        (response) => {
          this.loading = false;
          this.handleErrors(response);
        }
      );
  }
}
